module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (2).038268be.jpg";